<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item>内容版块</el-breadcrumb-item>
        <el-breadcrumb-item>院校专业</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">版块列表</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handlePositionCreate"
          >添加版块</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="版块标题"
          prop="title"
        >
          <el-input
            v-model="query.title"
            placeholder="输入版块名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="版块位置"
          prop="site"
        >
          <el-select
            v-model="query.site"
            placeholder="请选择"
          >
            <el-option
              v-for="item in sites"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="内容类型"
          prop="type"
        >
          <el-select
            v-model="query.type"
            placeholder="请选择"
          >
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="divider"></div>
      <div class="action-wrap">
        <el-button
          type="primary"
          @click="handleSearch"
        >搜索</el-button>
        <el-button @click="handleFormReset('searchForm')">重置</el-button>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="title"
            label="版块标题"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="site"
            label="版块位置"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{renderSite(scope.row.site)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            label="内容类型"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{renderType(scope.row.type)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="group_id"
            label="关联内容组"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              {{renderGroup(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="layout"
            label="布局方向"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{renderLayout(scope.row.layout)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="max_num"
            label="最大展示数量"
            min-width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="sort"
            label="排序值"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="状态"
            width="160"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 1?'success':'danger'">{{scope.row.status == 1 ? '正常' : '下线'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="180"
            align="center"
            fixed="right"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleToSectionEdit(scope.row, scope.$index)"
              >编辑</el-button>
              <el-button
                class="remove-text-button"
                size="mini"
                type="text"
                @click="handleToSectionRemove(scope.row, scope.$index)"
              >删除</el-button>
            </template>
          </el-table-column>
             <el-table-column
            label=""
            width="40"
            align="center"
            fixed="right"
            v-else
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                  ><span
                     @click="handleToSectionEdit(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      编辑
                    </span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    command="d"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToSectionRemove(scope.row, scope.$index)"
                      style="font-size:16px;color: #F56C6C;"
                    >
                      删除
                    </span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <SectionCreate
      :visible="createDialog"
      @close="createDialog = false"
      @submit="fetchSectionList"
    ></SectionCreate>
    <SectionEdit
      :visible="editDialog"
      :content="editRow"
      @close="editDialog = false"
      @submit="fetchSectionList"
    ></SectionEdit>
  </div>
</template>

<script>
import SectionCreate from '@/components/dialog/section/CollegeSectionCreate'
import SectionEdit from '@/components/dialog/section/CollegeSectionEdit'
import { collegeSectionList, collegeSectionDestroy } from '@/api/section'
import { productCategoryList } from '@/api/product'
import { articleCategoryList } from '@/api/article'

export default {
  components: {
    SectionCreate,
    SectionEdit
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      editRow: {},
      query: {
        title: '',
        site: '',
        type: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize') ? Number(localStorage.getItem('pageSize')) : 10,
        isPaging: 1
      },
      types: [
        { label: '全部', value: '' },
        { label: '课程', value: 1 },
        { label: '题库', value: 2 },
        { label: '阅读资料', value: 3 },
        { label: '实体资料', value: 4 },
        { label: '信息资讯', value: 5 },
        { label: '学长学姐', value: 6 }
      ],
      sites: [
        { label: '全部', value: '' },
        { label: '院校页', value: 1 },
        { label: '专业页', value: 2 }
      ],
      layouts: [
        { label: '横向', value: 'row' },
        { label: '纵向', value: 'column' }
      ],
      pageTotal: 10,
      results: [],
      productGroups: [],
      articleGroups: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
    }
  },
  created() {
    this.parseQuery()
    this.fetchProductCategoryList()
    this.fetchArticleCategoryList()
    this.fetchSectionList()
  },
  methods: {
    // 产品分类查询
    fetchProductCategoryList() {
      productCategoryList({ isPaging: 0 }).then(res => {
        if (res) {
          this.productGroups = res.list
        }
      })
    },
    // 文章分类查询
    fetchArticleCategoryList() {
      articleCategoryList({ isPaging: 0 }).then(res => {
        if (res) {
          this.articleGroups = res.list
        }
      })
    },
    // 版块列表请求
    fetchSectionList() {
      collegeSectionList(this.query).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchSectionList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchSectionList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchSectionList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchSectionList()
    },
    // 版块创建
    handlePositionCreate() {
      this.createDialog = true
    },
    // 版块编辑
    handleToSectionEdit(row) {
      this.editRow = Object.assign({}, row, { status: row.status == 1 ? true : false })
      this.editDialog = true
    },
    // 版块删除
    handleToSectionRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        collegeSectionDestroy({ id: row.id }).then(res => {
          this.$message.success(`删除成功`)
          this.fetchSectionList()
        })
      }).catch(() => { })
    },
    renderGroup(row) {
      let group = null
      if (row.group_id) {
        if ([1,3,2,4].includes(row.type)) {
          group = this.productGroups.find(v => v.id == row.group_id)
        } else if ([5].includes(row.type)) {
          group = this.articleGroups.find(v => v.id == row.group_id)
        }
      }
      return group ? group.name : ''
    },
    renderSite(site) {
      if (!site) {
        return ''
      }
      const list = this.sites.filter(item => item.value == site)
      if (list.length) {
        return list[0].label
      }
      return ''
    },
    renderType(type) {
      if (!type) {
        return ''
      }
      const list = this.types.filter(item => item.value == type)
      if (list.length) {
        return list[0].label
      }
      return ''
    },
    renderLayout(layout) {
      if (!layout) {
        return ''
      }
      const list = this.layouts.filter(item => item.value == layout)
      if (list.length) {
        return list[0].label
      }
      return ''
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach(key => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.type) {
        this.query.type = Number(this.query.type)
      }
      if (this.query.site) {
        this.query.site = Number(this.query.site)
      }
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(key => this.$route.query[key] != this.query[key])
      isSync && this.$router.replace({
        query: Object.assign({}, this.$route.query, this.query)
      })
    },
  }
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
}
</style>
